import { getVehicleColorFunction } from '@/common/queries/selections/vehicleColor/vehicleColorFunction';
import { InsuranceABV } from '@/common/types/SelectionOptions.type';
import { queryOptions } from '@tanstack/react-query';

export const getVehicleColorOption = ({
  insurance,
  name,
}: {
  insurance: InsuranceABV;
  name?: string;
}) =>
  queryOptions({
    queryKey: ['get_vehicle_color', insurance, name],
    queryFn: () => getVehicleColorFunction(insurance, name),
  });
